export const dictionary = {
  ORDER: {
    ES: "Tu pedido",
    EN: "Your order",
  },
  EMPTY_CART: {
    ES: "Tu cesta está vacía",
    EN: "Your cart is empty",
  },
  CONTINUE: {
    ES: "Continuar",
    EN: "Continue",
  },
  CHECKOUT: {
    ES: "Finalizar pedido",
    EN: "Checkout",
  },
  ORDER_SENT: {
    ES: "¡Tu pedido ha sido enviado!",
    EN: "Your order has been submited",
  },
  WHATSAPP_MESSAGE: {
    ES: "Hola, he realizado un pedido. ",
    EN: "Hi! I have placed an order. ",
  },
  CUSTOMER_NAME: {
    ES: "Tu nombre completo",
    EN: "Full name",
  },
  CUSTOMER_PHONE: {
    ES: "Teléfono de contacto",
    EN: "Contact number",
  },
  NO_FIELDS: {
    ES: "No hay preguntas",
    EN: "No questions",
  },
} as const;
